import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";
import { mastersBeforeLoad, mastersValidateSearch } from "./_masters";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/masters/deliverySpots",
  validateSearch: mastersValidateSearch,
  beforeLoad: mastersBeforeLoad,
  component: lazyRouteComponent(() => import("./masters.deliverySpots"), "DeliverySpotsPage"),
});
